import React from 'react';
import styles from './SuccessMessage.module.scss';

export type SuccessMessageType = 'validation' | 'refus' | 'demande_correction' | 'cloture';

interface SuccessMessageProps {
  type: SuccessMessageType;
  isVisible: boolean;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ type, isVisible }) => {
  const getMessageContent = () => {
    switch (type) {
      case 'validation':
        return {
          title: 'Validation envoyée avec succès',
          subtitle: 'La demande de dépense a été validée',
          icon: '✓',
          className: styles.success
        };
      case 'refus':
        return {
          title: 'Refus envoyé avec succès',
          subtitle: 'La demande de dépense a été refusée',
          icon: '✗',
          className: styles.error
        };
      case 'demande_correction':
        return {
          title: 'Demande de correction envoyée',
          subtitle: 'La demande de correction a été transmise',
          icon: '⚠',
          className: styles.warning
        };
      case 'cloture':
        return {
          title: 'Demande clôturée avec succès',
          subtitle: 'La demande de dépense a été clôturée',
          icon: '✓',
          className: styles.success
        };
      default:
        return {
          title: 'Action effectuée',
          subtitle: '',
          icon: '✓',
          className: styles.success
        };
    }
  };

  const messageContent = getMessageContent();

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`${styles.successMessage} ${messageContent.className}`}>
      <div className={styles.iconContainer}>
        <span className={styles.icon}>{messageContent.icon}</span>
      </div>
      <div className={styles.textContainer}>
        <h3 className={styles.title}>{messageContent.title}</h3>
        <p className={styles.subtitle}>{messageContent.subtitle}</p>
      </div>
    </div>
  );
};

export default SuccessMessage;
